//VocabTypedResponse is a quiz type that presents the user with a single EMI word and expects the English translation of that word
<template>
  <v-container>
    <v-layout column justify-space-around align-space-around>
      <v-flex>
        <h1 class="display-4 font-weight-thin font-italic">{{article}}{{wordDisplay}}</h1>
      </v-flex>
      <v-flex>
        <span style="font-size: 150%">Word Level: {{wordLevel}}</span>
      </v-flex>

      <v-flex ma-5>
        <v-form v-on:submit.prevent="onSubmit">
          <v-layout>
            <v-text-field label="Answer" ref="typeBox" v-model="userAnswer" autofocus></v-text-field>
            <v-btn @click="handleSkip" v-if="!answered"> Skip </v-btn>
          </v-layout>
          <v-btn @click="handleAnswer" v-if="!answered">Check</v-btn>
          <v-btn @click="onSubmit" v-else>Next</v-btn>
        </v-form>
      </v-flex>

      <v-flex v-if="answered">
        <v-card flat width="80%">
          <v-container fill-height fluid>
            <v-card-text>
              <p class="green--text" style="font-size: 300%" v-if="correct">
                Correct!
              </p>
              <p class="red--text" style="font-size: 300%" v-else>
                Incorrect!
              </p>
              <p class="secondary--text" style="font-size: 150%">Correct Answers: {{corAns}}</p>
            </v-card-text>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {  PARTS_OF_SPEECH, GENDER, VOWELS } from "@/constants.js";
import { handleInitialMutationSingular } from '@/nouns.js'
export default {
  name: "VocabTypedResponse",
  props: {
    prompt: Object
  },
  data() {
    return {
      userAnswer: "",
      correct: false,
      answered: false,
      corAns: "",
    };
  },
  created() {},
  methods: {
    setFocus () {
      this.$nextTick(() => {
        const theElement = this.$refs.typeBox.$el
        const input = theElement.querySelector('input:not([type=hidden]),textarea:not([type=hidden])')
        if (input) {
          setTimeout(() => {
            input.focus()
          }, 0)
        }
      }); 
    },
    onSubmit() {
      if (!this.answered) this.handleAnswer();
      else this.clear();
    },
    handleAnswer: function() {
      this.answered = true;
      var test = [];
      for (var i = 0; i < this.answers.length; i++) {
        if (this.partOfSpeech === PARTS_OF_SPEECH.noun) {
          test.push(" " + "the" + " " + this.answers[i]);
        } else {
          test.push(" " + this.answers[i]);
        }
      }
      this.corAns = test.toString();
      if (this.partOfSpeech === PARTS_OF_SPEECH.noun)
        //noun
        this.correct = this.checkArticle() && this.checkNounTranslation();
      else this.correct = this.checkTranslation();
      this.$emit("check", { answer: this.userAnswer, correct: this.correct });
      return;
    },
    handleSkip: function(){
      this.clear();
    },
    clear: function() {
      this.$emit("next");
      this.answered = false;
      this.userAnswer = "";
      this.corAns = "";
      this.setFocus();
    },
    checkNoun() {
      return this.checkArticle() && this.checkTranslation();
    },
    checkNounTranslation() {
      var wordAnswer = this.userAnswer.substring(4);
      return this.answers.map(a => a.toLowerCase()).includes(wordAnswer.toLowerCase());
    },
    checkTranslation() {
      return this.answers.map(a => a.toLowerCase()).includes(this.userAnswer.toLowerCase());
    },
    checkArticle() {
      var article = this.userAnswer.substring(0, 3);
      return article.toLowerCase() === "the";
    }
  },
  computed: {
    article() {
      if (this.partOfSpeech === PARTS_OF_SPEECH.noun) {
        let w = this.prompt.emiWord;
        let firstLetter = w.substring(0, 1);
        if (this.prompt && w) {
          if (VOWELS.indexOf(firstLetter) >= 0) return "an t-";
          else return "an ";
        } else return "";
      } else return "";
    },
    //gender: 1 = masculine, 2 = feminine, 3 = masculine-feminine, 4 = none
    gender() {
      if (this.prompt.gender) return parseInt(this.prompt.gender);
      else return "";
    },
    wordDisplay() {
      return handleInitialMutationSingular(this.prompt)
    },
    answers() {
      return Object.values(this.prompt.translations).map(el => el.translation);
    },
    answerArticle() {
      if (this.partOfSpeech === 1) return this.userAnswer.substring(0, 3);
      else return "";
    },
    partOfSpeech() {
      return parseInt(this.prompt.partOfSpeech);
    },
    wordLevel(currentWord) {
      var level = this.$store.getters.wordSRS(this.prompt);
      return level;
    }
  }
};
</script>

<style scoped>
incorrect {
  color: red;
}
</style>
